import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  padding: '3.2rem 2.4rem',
  background: 'linear-gradient(180deg, #3D9FDD 0%, #268CCD 100%)',
  opacity: 0.9,
  gap: '2.4rem',
  alignItems: 'center',
}

export const contentSx: SxProps<Theme> = {
  justfiyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  color: (theme) => theme.palette.common.white,
  gap: '2rem',
}

export const contentDescriptionSx: SxProps<Theme> = {
  justfiyContent: 'inherit',
  alignItems: 'inherit',
  textAlign: 'inherit',
  color: 'inherit',
  gap: '1.6rem',
}

export const imageSx: SxProps<Theme> = {
  maxWidth: { xs: '29.4rem', md: '38.5rem' },
  maxHeight: '100%',
  objectFit: 'contain',
  paddingY: '0.5rem',
}

export const scheduleDemoButtonSx: SxProps<Theme> = {
  minHeight: '5.2rem',
  boxShadow: '0px 3px 4.65px 0px rgba(0, 0, 0, 0.27)',
}
